<template>
  <div>
    <header class="login-header">
      <div class="logo">
        <img :src="$store.getters.settings.client.logo_2x" :srcset="$store.getters.settings.client.logo_4x +' 2x'"
             alt="logo">
      </div>
      <a v-if="$store.getters.settings.client.bilingual" :href="switchPath" class="language-toggle--overlay">عربي</a>
    </header>
    <main role="main" class="intro-pages-content">
      <section class="website-section website-form">
        <div class="container container--small">
          <form class="form-wrapper" v-on:submit.prevent="submit()" v-if="canReset">
            <fieldset>
              <legend class="legend-title">Reset Password</legend>
              <p class="form-desc">
                Please fill the form below to reset your password
              </p>
              <input class="form-input"
                     type="password"
                     placeholder="New Password*"
                     @blur="$v.formData.password.$touch()"
                     :class="{'is-invalid':$v.formData.password.$error}"
                     v-model="formData.password">
              <div class="error" v-if="$v.formData.password.$error && !$v.formData.password.required">Password is
                required.
              </div>
              <div class="error" v-if="$v.formData.password.$error && !$v.formData.password.minLength">Password
                must have at least {{ $v.formData.password.$params.minLength.min }} letters.
              </div>

              <input class="form-input"
                     type="password"
                     placeholder="Confirm New Password*"
                     @blur="$v.formData.confirmPassword.$touch()"
                     :class="{'is-invalid':$v.formData.confirmPassword.$error}"
                     v-model="formData.confirmPassword">
              <div class="error"
                   v-if="$v.formData.confirmPassword.$error && !$v.formData.confirmPassword.sameAsPassword">
                Passwords must be identical.
              </div>
              <div class="form-actions">
                <a class="t-text-color form-actions__link">*Mandatory field.</a>
                <div class="form-btns-group">
                  <button class="btn default-btn" @click="$router.push({'name':'Login'})">Cancel</button>
                  <button class="btn t-bg-color">Send</button>
                </div>
              </div>
              <p if="errorReset!=''" class="form-desc t-text-color">{{errorReset}}</p>
            </fieldset>
          </form>
          <div class="" v-if="showErrorCode">
            <form class="form-wrapper">
              <fieldset>
                <legend class="legend-title">Reset Password</legend>
                <p class="form-desc t-text-color">{{errorCodeMessage}}</p>
                <div class="form-actions">
                  <a class="t-text-color form-actions__link">&nbsp;</a>
                  <button class="btn default-btn" @click="$router.push({'name':'Login'})">Return</button>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </section>
      <div class="popup submission" v-if="showModal" @click.self="showModal = false">
        <div class="popup-info submission-info">
          <div class="submission-info__icon check"></div>
          <div class="popup-info__message">
            Thank you!
            <br>
            Your password has been changed successfully, please try login using your new password.
          </div>
          <button class="popup-btn btn t-bg-color" @click.self="$router.push({'name':'Login'})">Login</button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  import { required, sameAs, minLength } from 'vuelidate/lib/validators'

  export default {
    computed: {
      switchPath () {
        return '/ar' + this.$route.path
      }
    },
    data () {
      return {
        canReset: false,
        showModal: false,
        showErrorCode: false,
        errorCodeMessage: '',
        errorReset: '',
        formData: {
          userId: '',
          code: '',
          password: '',
          confirmPassword: ''
        }
      }
    },
    validations: {
      formData: {
        password: {
          required,
          minLength: minLength(6)

        },
        confirmPassword: {
          sameAsPassword: sameAs('password')
        }
      }
    },
    name: 'Reset',
    methods: {
      submit () {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          this.formData.userId = this.$route.params.id
          this.formData.code = this.$route.params.code
          let qs = require('qs')
          let vm = this
          this.axios.post('/recovery/reset', qs.stringify(this.formData))
            .then(response => {
              if (response.data.success === 'success') {
                vm.showModal = true
                vm.formData = {
                  password: '',
                  confirmPassword: '',
                  userId: '',
                  code: ''
                }
                vm.$v.$touch()
                vm.$v.$reset()
              } else {
                vm.errorReset = response.data.message
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      }
    },
    mounted () {
      this.formData.userId = this.$route.params.id
      this.formData.code = this.$route.params.code
      let qs = require('qs')
      this.axios.post('/recovery/check', qs.stringify(this.formData)).then(response => {
        if (response.data.success === 'success') {
          this.canReset = true
        } else {
          this.canReset = false
          this.showErrorCode = true
          this.errorCodeMessage = response.data.message
        }
      })
        .catch(error => {
          console.log(error)
        })
    },
    created () {
      this.$store.dispatch('setIsLoaded', true)
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/auth/Reset.vue